import { createFileRoute } from '@tanstack/react-router'
import { MaintenanceActions } from '../../../features/admin/MaintenanceActions'
import { DatabaseSeedCard } from '../../../features/admin/DatabaseSeedCard'
import { NotificationPreferences } from '../../../features/admin/NotificationPreferences'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/maintenance')({
  component: AdminMaintenanceRoute,
})

/* ───── Route Component ───── */

function AdminMaintenanceRoute() {
  return (
    <div className="space-y-8 p-6">
      <MaintenanceActions />
      <NotificationPreferences />
      <DatabaseSeedCard />
    </div>
  )
}
